const TIME_BUCKET_LABELS = {
  breakfast: 'Breakfast',
  before_school: 'Before school',
  morning: 'Morning',
  lunch: 'Lunch',
  after_lunch: 'After lunch',
  nap: 'Nap',
  afternoon: 'Afternoon',
  late_afternoon: 'Late afternoon',
  before_leaving_home: 'Before leaving home',
  dinner: 'Dinner',
  evening: 'Evening',
  bedtime: 'Bedtime',
};

export const getTimeBucketLabel = (bucket = '') => {
  const normalized = String(bucket || '').trim().toLowerCase();
  if (!normalized) {
    return '';
  }

  return TIME_BUCKET_LABELS[normalized] || normalized.replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const getTimeUnclearLabel = () => 'No exact time';
